import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';

export default function MfaSetup({ token, onComplete }) {
  const [setupData, setSetupData] = useState(null);
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`https://hospital-clinic.harrydenny2712.workers.dev/api/auth/mfa/setup`, {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        setSetupData(data);
      } else {
        setError(data.error || 'Failed to start MFA setup');
      }
      setLoading(false);
    })
    .catch(err => {
      setError('Connection failed.');
      setLoading(false);
    });
  }, [token]);

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    
    try {
      const res = await fetch(`https://hospital-clinic.harrydenny2712.workers.dev/api/auth/mfa/verify`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ mfaCode: code })
      });
      const data = await res.json();
      
      if (data.success) {
        onComplete();
      } else {
        setError(data.error || 'Invalid code');
      }
    } catch (err) {
      setError('Verification failed');
    }
  };

  if (loading) return <div className="page-content" style={{textAlign:'center', padding:'80px'}}>Starting MFA Setup...</div>;

  return (
    <div className="login-wrapper animate-fade">
      <div className="login-container glass-card" style={{ maxWidth: '400px', textAlign: 'center' }}>
        <div className="login-header">
          <div className="brand-logo">🛡️</div>
          <h2>Secure Your Account</h2>
          <p>Scan the QR code with Google Authenticator or Authy to enable Two-Factor Authentication.</p>
        </div>

        {error && <div className="login-error-alert animate-fade">⚠️ {error}</div>}

        {setupData && (
          <>
            <div style={{ background: '#fff', padding: '16px', display: 'inline-block', borderRadius: '8px', margin: '20px 0' }}>
              <QRCodeSVG value={setupData.uri} size={180} />
            </div>
            
            <p style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>
              Or enter secret manually:<br/>
              <code style={{ background: 'var(--bg-input)', padding: '4px 8px', borderRadius: '4px', marginTop: '6px', display: 'inline-block' }}>{setupData.secret}</code>
            </p>

            <form onSubmit={handleVerify} style={{ marginTop: '24px' }}>
              <div className="form-group" style={{ textAlign: 'left' }}>
                <label className="form-label" htmlFor="mfaCode">Enter 6-digit Code</label>
                <input
                  id="mfaCode"
                  type="text"
                  className="form-control"
                  placeholder="123456"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  autoComplete="one-time-code"
                />
              </div>
              <button type="submit" className="btn btn-primary btn-block" style={{ marginTop: '16px' }}>Verify and Enable</button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
